import { SortByOptionsType, SortDirectionOptionsType } from '@shared/generated';

export enum JobSortingOptions {
  NEWEST = 'newest',
  OLDEST = 'oldest',
  ALPHABETICAL = 'alphabetical',
  REVERSE_ALPHABETICAL = 'reverse_alphabetical',
  EARLIEST_INSTALL_START_DATE = 'earliest_install_start_date',
  LATEST_INSTALL_START_DATE = 'latest_install_start_date'
}
export const jobSortOptionsMapping: Record<
  JobSortingOptions,
  { sortBy: SortByOptionsType; sortDirection: SortDirectionOptionsType }
> = {
  [JobSortingOptions.NEWEST]: {
    sortBy: SortByOptionsType.CREATED_AT,
    sortDirection: SortDirectionOptionsType.DESC
  },
  [JobSortingOptions.OLDEST]: {
    sortBy: SortByOptionsType.CREATED_AT,
    sortDirection: SortDirectionOptionsType.ASC
  },
  [JobSortingOptions.ALPHABETICAL]: {
    sortBy: SortByOptionsType.JOB_NAME,
    sortDirection: SortDirectionOptionsType.ASC
  },
  [JobSortingOptions.REVERSE_ALPHABETICAL]: {
    sortBy: SortByOptionsType.JOB_NAME,
    sortDirection: SortDirectionOptionsType.DESC
  },
  [JobSortingOptions.EARLIEST_INSTALL_START_DATE]: {
    sortBy: SortByOptionsType.INSTALL_START_DATE,
    sortDirection: SortDirectionOptionsType.ASC
  },
  [JobSortingOptions.LATEST_INSTALL_START_DATE]: {
    sortBy: SortByOptionsType.INSTALL_START_DATE,
    sortDirection: SortDirectionOptionsType.DESC
  }
};
